import { useEffect, useState } from "react";
import { useStore } from "../context/StoreContext";
import { fetchProducts } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Link } from "react-router-dom";

export default function WishlistPage() {
  const { wishlist } = useStore();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts({})
      .then((all) => setItems(all.filter((p) => wishlist.includes(p.id))))
      .finally(() => setLoading(false));
  }, [wishlist]);

  return (
    <main data-testid="wishlist-page" className="bg-[#0A0A0A] min-h-screen pt-[100px] pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-3">✦ Saved</div>
        <h1 className="font-serif-display text-6xl md:text-8xl tracking-tighter">
          Your <em className="not-italic gold-text">wishlist.</em>
        </h1>
        <p className="text-[#A3A3A3] mt-4 text-sm">{items.length} pieces saved</p>

        {!loading && items.length === 0 && (
          <div className="mt-16 text-center">
            <p className="font-serif-display italic text-2xl text-[#A3A3A3]">
              Nothing here yet.
            </p>
            <Link to="/shop" className="btn-gold mt-8 inline-flex">Discover</Link>
          </div>
        )}

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      </div>
    </main>
  );
}
